<template>
  <div id="languageSelector" refs="languageSelector" :class="{'visible': isVisible, 'plain-card': $utils.isPageForLicenses()}">
    <div class="content">
      <div class="header">
        <div @click="handleCloseDialog" class="close-icon el-icon-close">
          <el-icon><Close /></el-icon>
        </div>
        <div class="title">{{$t('label.selectLanguage')}}</div>
      </div>

      <div class="body">
        <div class="languages">
          <template v-for="(language, indx) in languages" :key="indx">
            <div @click="handleLanguageClick(language)" :class="['language', {'selected': selectedLanguage && selectedLanguage.code === language.code }]">
              <div class="label">{{language.label}}</div>
            </div>
          </template>
        </div>
      </div>

      <div class="footer">
        <el-button @click="handleSaveChanges" class="cstm-btn-white width-auto">{{$t('label.saveChanges')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script src="./language-selector.js"></script>
<style lang="scss" src="./language-selector.scss"></style>
